<template>
    <div class="container">
        <card class="pd12">
            <div class="txt">共{{pagination.total}}次</div>
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="loadMoreList"
                v-if="list.length > 0"
            >
                <div class="mt24" v-for="(item,index) in list" :key="index">
                    <div class="txt mb17">{{item.createTime.substring(0,10)}}</div>
                    <div class="tit">
                        {{item.previousAddress}}
                        <img class="img" src="@/assets/guideSystem/old.png" />
                        <div class="vline"></div>
                    </div>
                    <div class="tit">
                        {{item.newAddress}}
                        <img class="img" src="@/assets/guideSystem/new.png" />
                    </div>
                </div>
            </van-list>
        </card>
            <empty :type="3" v-if="list.length === 0 && !loading"></empty>
    </div>
</template>
<script>
    import card from '../travelAgency/components/card';
    import empty from 'comps/empty';
    import api from '../../service/index'
    export default {
        components: {
            card,
            empty
        },

        data () {
            return {
                list: [],
                pagination: { total: 0, current_page: 1, page_size: 20 },
                finished: false,
                loading: false,
                guideId: 0
            };
        },

        computed: {},

        watch: {},

        methods: {
            loadMoreList () {
                this.getList();
            },
            getList () {
                this.loading = true
                api.regionalChangeList({ guideId: this.guideId, pageSize: this.pagination.page_size, pageNo: this.pagination.current_page }).then(res => {
                    console.log(res)
                    res = res.data
                    this.loading = false
                    this.list = this.list.concat(res.list)
                    if ((res.pagination.current_page * res.pagination.pageSize) < res.pagination.total) {
                        res.pagination.current_page = res.pagination.current_page + 1
                        this.finished = false
                    } else {
                        this.finished = true
                    }
                    this.pagination = res.pagination
                })
            }
        },

        mounted () {},
        created () {
            this.guideId = this.$route.query.guideId;
            this.pagination = { total: 0, current_page: 1, page_size: 20 }
            this.finished = false
            this.loading = false
            this.list = []
            this.getList();
        }
    };
</script>
<style scoped lang="less">
.container {
    height: 100vh;
    background-color: @base-bgcolor;
    padding: 16px 12px;
    box-sizing: border-box;

    .pd12 {
        .txt {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
        }
        .tit {
            position: relative;
            margin-left: 24px;
            font-size: 16px;

            font-family: PingFang SC, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
            &:first-child {
                margin-top: 17px;
            }
        }
        .img {
            position: absolute;
            left: -24px;
            top: 50%;
            transform: translateY(-50%);
            width: 16px;
            height: 16px;
            z-index: 1;
        }
        .vline {
            position: absolute;
            left: -16px;
            top: 50%;
            width: 1px;
            height: 30px;
            background: #eaeaea;
        }
    }
}
</style>
